import { infiniteQueryOptions } from '@tanstack/react-query';
import type { ClientSortDirection, ClientStatus } from '@packages/types';
import { listClients } from '@packages/api/endpoints/client.js';
import { queryKeys, getNextPageParam, DEFAULT_LIST_PAGE_SIZE } from '@packages/api';

export type ClientListSortField = 'name' | 'lastActivityDate';

export interface ClientListFilters {
  search: string;
  sortField: ClientListSortField;
  sortDirection: ClientSortDirection;
  status: ClientStatus | '';
}

/** What the clients page opens on, so a prefetch warms the entry it reads first. */
export const DEFAULT_CLIENT_LIST_FILTERS: ClientListFilters = {
  search: '',
  sortField: 'lastActivityDate',
  sortDirection: 'desc',
  status: '',
};

export function clientListQueryOptions(accountId: string, filters: ClientListFilters) {
  return infiniteQueryOptions({
    queryKey: [...queryKeys.clients(accountId), 'current', filters],
    queryFn: ({ pageParam }) =>
      listClients(accountId, {
        cursor: pageParam,
        limit: DEFAULT_LIST_PAGE_SIZE,
        search: filters.search || undefined,
        sortBy: filters.sortField,
        sortDirection: filters.sortDirection,
        status: filters.status || undefined,
      }),
    getNextPageParam,
    initialPageParam: undefined as string | undefined,
  });
}
